import React from "react";
import { Box } from "@mui/material";

import Loader from "../../../../components/Loader";
import MuiTable from "../../board/components/BoardTable/MuiTable";
import { useResponsive } from "../../../../hooks/useResponsive";
import { userManagementColumns as columns } from "./userManagementColumns";
import { useUserManagementTable } from "../hooks/useUserManagementTable";

function UserTable() {
  const isMobile = useResponsive("down", "md");
  const { isLoading, isError, rows, icon } = useUserManagementTable();

 
  return (
    <>
      {isLoading && (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      )}
      {!isLoading && isError && (
        <div className="loader-center">
          <p>Error</p>
        </div>
      )}
      {!isLoading && !isError && (
        <Box p={isMobile && 1} mt={isMobile && 1}>
          <MuiTable
            initialRows={rows || []}
            columns={columns(icon)}
            defaultSort={"first_name"}
            headerBgColor={"#F2F4F6"}
            scrollHeight={"calc(96vh - 120px)"}
          />
        </Box>
      )}
    </>
  );
}

export default React.memo(UserTable);
